export default "__VITE_ASSET__5d1777ad__"